<template>
 <v-layout
    justify-center
    class="activity"
    :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`, 'color': `${ColorContent} !important`}"
    wrap
  >
  <v-flex xs12 style="margin-top:10px;">
    <v-menu offset-y :value="showFilter">
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="searchText"
          :label="$t('common.search', locale)"
          append-icon="mdi-magnify"
          @input="handleSearch"
          @click:append-outer="onSearch"
          @click:prepend="handleShowFilter"
          solo
          style="margin: 10px 10px 20px 10px"
          prepend-icon="mdi-filter"
          hide-details
        />
      </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in types"
        :key="index"
        @click="handleChangeType(item.ID)"
      >
        <v-list-item-title>{{ item.Name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  </v-flex>

  <!-- <v-flex xs12 style="margin-top:-20px;">
    <v-autocomplete
      v-if="types && types.length > 0"
      v-model="selectedType"
      solo
      :items="types"
      item-text="Name"
      item-value="ID"
      @input="onSearch"
      style="margin: 10px;"
    />
  </v-flex> -->
  <v-flex xs12 
    v-for="(item) in channelListFilter"
    :key="item.ID"
    style="margin: 0 10px;"
    class="main-channel"
  >
    <v-layout
      wrap
    >
      <v-flex xs2 class="channel">
        <center style="margin: 20px 0 0 0;">{{item.Number}}</center>
      </v-flex>
      <v-flex xs3 class="image">
        <!--v-img :key="item.Name" :src="item.Image" :lazy-src="item.Image" style="width:90%;height:auto" /-->
        <v-img :key="item.Name" :src="item.Image" :lazy-src="item.Image" style="height:80%;margin-top:10%;width:auto" />
      </v-flex>
      <v-flex xs7 class="detail">
        <p class="title">{{item.Name}}</p>
        <p class="subtitle">{{item.NativeName}}</p>
      </v-flex>
    </v-layout>
  </v-flex>
    <!-- <v-flex
      xs12
      style="padding-bottom: 0px;padding-top: 0px;padding-left: 20px;padding-right: 20px;"
    >
      <div
        style="padding-top: 15px; padding-bottom: 15px;font-size:22px;"
        class="text-center"
      >
        {{ $t(sDay.pre).toUpperCase() }} {{ $t(sDay.month).toUpperCase() }} {{ sDay.pos.toUpperCase() }}
      </div>
      <div
        style="opacity: 0.8;position: static; height:64px;top:0px;margin-bottom:20px;"
        :style="{ 'background-color': `${BGColor}` }"
      >
        <table border="0" style="width:100%;height:100%;border:0px;" cellspacing="0" cellpadding="0">
          <tr>
            <td class="td" v-for="(day, index) in week" 
              :key="`td${index}`"
              :style="{ 'padding-top': isSimulation || isDesktop ? '20px' : '','background-color': daysToAdd === index ? ColorContent : BGColor, 'border-right': index !== 6 ? '1px solid white' : '0px' }" 
              style="text-align: center;color:white;width:14.19%"
              @click="() => handleAddDays(index)"
            >
              {{ $t(`common.${day}`).substring(0, 2) }}
            </td>
          </tr>
        </table>
      </div>
      <v-container
        fluid
        grid-list-md
      >
        <v-layout
          row
          wrap
          style="margin-bottom: 20px;"
        >
          <v-flex
            v-if="!shows || shows.length === 0"
            :style="{ 'background-color': ColorContent, 'color': BGColorContent }"
            style="margin: 15px;text-align: center;padding-top:10px;padding-bottom:10px;opacity:0.9;"
          >
            {{ $t('activity.messages.noActivities').toUpperCase() }}
          </v-flex>
          <v-flex
            v-for="(show) in shows"
            :key="show.ID"
            v-bind="{ [`xs${isDesktop ? 12 : 12}`]: true }"
            style="margin-top: 5px;margin-bottom: 6px;"
          >
            <v-card
              class="mx-auto"
              max-width="344px"
              :style="{ 'opacity': show.Availability.finished ? '0.3' : '1' }"
            >
              <v-img
                :src="show.Image"
                height="auto"
              ></v-img>
              <v-card-title>
                <v-layout
                  row
                  wrap
                  style="margin-top:5px;margin-bottom:0px;"
                >
                  <v-flex
                    xs8
                    style="font-size: 16px;line-height:1.2;"
                  >
                    {{ show.Title.toUpperCase() }}
                  </v-flex>
                  <v-flex
                    xs4
                    style="text-align: right;padding-right: 15px;padding-bottom:0px;"
                  >
                  </v-flex>
                </v-layout>
                <div style="width: 100%">
                  <v-icon
                    :style="{ 'color': show.Availability.time && show.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : ColorContent}"                  
                    dark
                    class="activity-button"
                    style="margin-left: 0px;font-weight: 500;font-size: 17px;"
                  >
                    mdi-clock-outline
                  </v-icon>
                  <span
                    :style="{ 'color': show.Availability.time && show.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : ColorContent}"                  
                    style="margin-left: 0;font-weight: 500;font-size: 17px;"
                  >
                    {{ show.TimeStart.substring(0, 5) }}-{{ show.TimeEnd.substring(0, 5) }}
                  </span>
                </div>
                <div style="width: 100%">
                  <span
                    style="margin-left: 0;font-size: 13px;"
                    :style="{ 'color': ColorContent}" 
                  >{{ show.Site }}</span>
                </div>
                <div style="margin-bottom: 5px;margin-left: 0;font-size: 13px;width: 100%;line-height:normal" v-if="show.Description && show.Description.length > 0">
                  {{ show.Description }}
                </div>
              </v-card-title>              
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex> -->
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import axios from 'axios'
  import api from '@/services/api'
  import constants from '@/constants'
  export default {
    components: {
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      }
    },
    data: () => ({
      handleSearch: null,
      searchText: '',
      channelList: null,
      channelListFilter: null,
      DviewLink: null,
      shows: null,
      daysToAdd: 0,
      week: [],
      typeActivity: 0,
      types: [],
      selectedType: null,
      showFilter: false
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'BGColor', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile();
      },
      isPI () {
        if (this.$route.query.PI) return true
        return false
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      sDay () {
        let dToday = new Date()
        const dActual = new Date().setDate(dToday.getDate() + this.daysToAdd)
        const pos = `${new Date(dActual).getDate()}, ${new Date(dActual).getFullYear()}`

        const result = {
          pre: this.daysToAdd === 0 ? 'common.today' : this.daysToAdd === 1 ? 'common.tomorrow' : '',
          month: `common.m${new Date(dActual).getMonth()}`,
          pos
        }
        return result
      }
    },
    watch: {
      'data.ChannelListType': {
        handler: function (newValue) {
          this.channelListType = newValue
          this.getData()
        },
        deep: true
      },
      locale () {
        this.getData()
      }
    },
    mounted () {
      this.channelListType = this.data.ChannelListType ? this.data.ChannelListType : null
      this.getData()
      this.handleSearch = _.debounce(() => {
        this.onSearch()        
      }, 500)
    },
    methods: {
      handleShowFilter() {
        if (this.showFilter) {
          this.showFilter = false
          setTimeout(() => {
            this.showFilter = true
          }, 500)
        } else this.showFilter = true
      },
      handleChangeType (value) {
        this.selectedType = value
        this.showFilter = false
        this.onSearch()
      },
      getData () {
        const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
        api.getAll('contents', false, 1, 100000, '', enterpriseIDDomain.concat('/channel-list-type/')).then(response => {            
          this.types = [
            {
              ID: null,
              Name: this.$t('common.all', this.locale)
            }
          ]
          this.types.push(...response.map (item => {
            item.Name = constants.isoLangs[item.ID] ? constants.isoLangs[item.ID].nativeName.split(',')[0] : ''
            return item
          }))
        })
        api.getAll('contents', false, 1, 100000, '', enterpriseIDDomain.concat('/channel-list/')).then(response => {          
          this.channelList = this.channelListType && this.channelListType > 0 ? response.filter(x => x.Country === this.channelListType) : response          
          this.channelList = this.channelList.map(item => {        
            item.NativeName = constants.isoLangs[item.Country] ? constants.isoLangs[item.Country].nativeName.split(',')[0] : ''
            return item
          })
          this.onSearch()
        })
      },
      onSearch () {
        this.channelListFilter = this.channelList.filter(x => 
          (
            x.Number.toUpperCase() === this.searchText.toUpperCase() || x.Name.toUpperCase().indexOf(this.searchText.toUpperCase()) >= 0
          ) && (
            !this.selectedType || x.Country.toUpperCase() === this.selectedType.toUpperCase()
          )
        )

          // console.log(response)
      }
    }
  }
</script>
<style scoped>
  .main-channel {
    border-bottom: 1px solid #0000004D;
  }
  .channel {
    font-size: 25px;
    font-weight: 700;
  }
  .detail {
    padding: 0 5px;
    font-family: Roboto, Arial, Helvetica, sans-serif;
  }
  .title {
    font-weight: 400;
    font-size: 24px;
    margin: 15px 0 0 0;
    line-height: 1;    
  }
  .subtitle {
    font-weight: 200;
    font-size: 15px;
    margin: 0px;
    text-transform: capitalize;
  }
  .image {
    padding: 5px;
  }
</style>
